import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import Layout from '@/views/layout/Layout.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/Login.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/replays/view/:id',
    name: 'ReplayView',
    component: () => import('@/views/replay/ReplayView.vue'),
    meta: { title: '查看回放', fullscreen: true }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/Dashboard.vue'),
        meta: { title: '仪表盘', icon: 'el-icon-s-home' }
      },
      {
        path: 'users',
        name: 'UserManagement',
        component: () => import('@/views/user/UserManagement.vue'),
        meta: { title: '用户管理', icon: 'el-icon-user' }
      },
      {
        path: 'teachers',
        name: 'TeacherManagement',
        component: () => import('@/views/teacher/TeacherManagement.vue'),
        meta: { title: '老师管理', icon: 'el-icon-s-custom' }
      },
      {
        path: 'assistants',
        name: 'AssistantManagement',
        component: () => import('@/views/teacher/AssistantManagement.vue'),
        meta: { title: '助教管理', icon: 'el-icon-user' }
      },
      {
        path: 'formal-class-hours',
        name: 'FormalClassHourManagement',
        component: () => import('@/views/class-hour/FormalClassHourManagement.vue'),
        meta: { title: '正式课时', icon: 'el-icon-notebook-2', group: 'class-hour' }
      },
      {
        path: 'trials',
        name: 'TrialPermission',
        component: () => import('@/views/trial/TrialPermission.vue'),
        meta: { title: '试听权限', icon: 'el-icon-video-play', group: 'class-hour' }
      },
      {
        path: 'trial-bookings',
        name: 'TrialBookingManagement',
        component: () => import('@/views/trial/TrialBookingManagement.vue'),
        meta: { title: '试听预约', icon: 'el-icon-date', group: 'booking' }
      },
      {
        path: 'formal-bookings',
        name: 'FormalBookingManagement',
        component: () => import('@/views/booking/FormalBookingManagement.vue'),
        meta: { title: '正课预约', icon: 'el-icon-date', group: 'booking' }
      },
      {
        path: 'orders',
        name: 'OrderManagement',
        component: () => import('@/views/order/OrderManagement.vue'),
        meta: { title: '订单管理', icon: 'el-icon-s-order' }
      },
      {
        path: 'refunds',
        name: 'RefundManagement',
        component: () => import('@/views/refund/RefundManagement.vue'),
        meta: { title: '退款管理', icon: 'el-icon-money' }
      },
      {
        path: 'agents',
        name: 'AgentManagement',
        component: () => import('@/views/agent/AgentManagement.vue'),
        meta: { title: '代理管理', icon: 'el-icon-s-cooperation' }
      },
      {
        path: 'commissions',
        name: 'CommissionManagement',
        component: () => import('@/views/commission/CommissionManagement.vue'),
        meta: { title: '佣金管理', icon: 'el-icon-coin' }
      },
      {
        path: 'courses/levels',
        name: 'CourseLevelManagement',
        component: () => import('@/views/course/CourseLevelManagement.vue'),
        meta: { title: '课程套餐', icon: 'el-icon-goods', group: 'course' }
      },
      {
        path: 'courses/homepage-teachers',
        name: 'HomepageTeacherManagement',
        component: () => import('@/views/course/HomepageTeacherManagement.vue'),
        meta: { title: '首页教师', icon: 'el-icon-user', group: 'course' }
      },
      {
        path: 'replays',
        name: 'ReplayManagement',
        component: () => import('@/views/replay/ReplayManagement.vue'),
        meta: { title: '回放管理', icon: 'el-icon-film' }
      },
      {
        path: 'withdrawals',
        name: 'WithdrawalManagement',
        component: () => import('@/views/withdrawal/WithdrawalManagement.vue'),
        meta: { title: '提现管理', icon: 'el-icon-wallet' }
      },
      {
        path: 'agent-materials',
        name: 'MaterialManagement',
        component: () => import('@/views/agent/MaterialManagement.vue'),
        meta: { title: '物料管理', icon: 'el-icon-folder-opened' }
      },
      {
        path: 'logs',
        name: 'OperationLog',
        component: () => import('@/views/logs/OperationLog.vue'),
        meta: { title: '操作日志', icon: 'el-icon-document' }
      },
      {
        path: 'config/ad-banners',
        name: 'AdBannerManagement',
        component: () => import('@/views/config/AdBannerManagement.vue'),
        meta: { title: '广告位管理', icon: 'el-icon-picture' }
      },
      {
        path: 'config/scroll-messages',
        name: 'ScrollMessageManagement',
        component: () => import('@/views/config/ScrollMessageManagement.vue'),
        meta: { title: '滚动消息管理', icon: 'el-icon-bell' }
      },
      {
        path: 'config/subjects',
        name: 'SubjectManagement',
        component: () => import('@/views/config/SubjectManagement.vue'),
        meta: { title: '科目管理', icon: 'el-icon-notebook-2' }
      },
      {
        path: 'config/grades',
        name: 'GradeManagement',
        component: () => import('@/views/config/GradeManagement.vue'),
        meta: { title: '年级管理', icon: 'el-icon-school' }
      },
      {
        path: 'config/schools',
        name: 'SchoolManagement',
        component: () => import('@/views/config/SchoolManagement.vue'),
        meta: { title: '学校管理', icon: 'el-icon-office-building' }
      },
      {
        path: 'config/grade-subject',
        name: 'GradeSubjectMapping',
        component: () => import('@/views/config/GradeSubjectMapping.vue'),
        meta: { title: '年级科目关联', icon: 'el-icon-link' }
      },
      {
        path: 'config/time-slots',
        name: 'TimeSlotManagement',
        component: () => import('@/views/config/TimeSlotManagement.vue'),
        meta: { title: '时间段管理', icon: 'el-icon-time' }
      },
      {
        path: 'config/trial-benefits',
        name: 'TrialBenefitManagement',
        component: () => import('@/views/config/TrialBenefitManagement.vue'),
        meta: { title: '试听权益管理', icon: 'el-icon-present' }
      },
      {
        path: 'config/home-texts',
        name: 'HomeTextManagement',
        component: () => import('@/views/config/HomeTextManagement.vue'),
        meta: { title: '首页文案管理', icon: 'el-icon-document' }
      },
      {
        path: 'config/site-config',
        name: 'SiteConfigManagement',
        component: () => import('@/views/config/SiteConfigManagement.vue'),
        meta: { title: '通用配置', icon: 'el-icon-tools' }
      },
      {
        path: 'config/customer-service',
        name: 'CustomerServiceConfig',
        component: () => import('@/views/config/CustomerServiceConfig.vue'),
        meta: { title: '客服配置', icon: 'el-icon-service' }
      },
      {
        path: 'config/consultations',
        name: 'ConsultationManagement',
        component: () => import('@/views/config/ConsultationManagement.vue'),
        meta: { title: '在线咨询', icon: 'el-icon-chat-line-square' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  // base 跟随 vue.config.js 的 publicPath（生产环境为 /admin/）
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const token = store.state.token
  if (to.path === '/login') {
    next()
  } else {
    if (token) {
      next()
    } else {
      next('/login')
    }
  }
})

export default router
